import { ActivityReportService } from 'data/services';
import { ActivityReportInternshipServiceInterface } from 'domain/services';
import { makeActivityReportInternshipLocation } from 'main/factories/usecases/reports/activity-report-internship-location-factory';

export const makeActivityReportInternshipLocationService =
  (): ActivityReportInternshipServiceInterface => {
    return new ActivityReportService(makeActivityReportInternshipLocation());
  };
